import { render, staticRenderFns } from "./RelocationsTable.vue?vue&type=template&id=079e0508&"
import script from "./RelocationsTable.vue?vue&type=script&lang=ts&"
export * from "./RelocationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports